module.exports = __webpack_public_path__ + "img/xlm.29ac2fa4.svg";